const ExchangeHorizontal = ({ size = 11, className = '', currentColor = '#5C3DFA' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 11 11"
      fill={currentColor}
      aria-hidden="true"
      className={className}
    >
      <path
        d="M1.83301 7.79199H7.33301M1.83301 7.79199L3.43717 6.18783M1.83301 7.79199L3.43717 9.39616M3.20801 3.20866H9.16634M9.16634 3.20866L7.56217 1.60449M9.16634 3.20866L7.56217 4.81283"
        stroke={currentColor}
        strokeWidth="0.916667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ExchangeHorizontal;
